/**
 * DecorativeStar — 4-point sparkle star with optional pulse animation
 */

import { motion } from 'framer-motion';
import { kidPalette } from '../../styles/kidPalette';

interface DecorativeStarProps {
  size?: number;
  color?: string;
  className?: string;
  pulse?: boolean;
}

export default function DecorativeStar({
  size = 24,
  color = kidPalette.dandelion,
  className = '',
  pulse = false,
}: DecorativeStarProps) {
  return (
    <motion.svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={`pointer-events-none ${className}`}
      animate={pulse ? { scale: [1, 1.3, 1], opacity: [0.7, 1, 0.7] } : undefined}
      transition={pulse ? { repeat: Infinity, duration: 2, ease: 'easeInOut' } : undefined}
    >
      <path
        d="M12 0C12 0 14 8 12 12C12 12 8 12 0 12C0 12 8 12 12 12C12 12 12 14 12 24C12 24 12 14 12 12C12 12 14 12 24 12C24 12 14 12 12 12C12 12 12 8 12 0Z"
        fill={color}
      />
    </motion.svg>
  );
}
